export const ActionTypes = {
  // Set Boolean value for Side Bar
  SHOW_HIDE_SIDE_BAR: 'services/common/show_hide_side_bar',
  // Set Loader for an action
  SET_LOADER_AFTER_UPDATE: 'services/common/set_loader_after_update',
  // Set Loader for an action
  SET_LOADER_IDEAL_DATASET: 'services/common/set_loader_ideal_dataset',
  // Global Dashboard Current view
  CURRENT_VIEW_GLOBAL_DASHBOARD: 'services/common/current_view_global_dashboard',
  // reset db
  RESET_DB: 'services/common/reset_db',
  // current View Factory dashboard
  CURRENT_VIEW_FACTORY_DASHBOARD: 'services/common/current_view_factory_dashboard',
  // Show Back Button
  SHOW_BACK_FACTORY_BUTTON: 'services/common/show_back_factory_button',
  // Factory Actions
  FETCH_ALL_FACTORIES: 'services/common/fetch_all_factories',
  SET_ALL_FACTORIES: 'services/common/set_all_factories',
  SET_ALL_SIMULATORS: 'services/common/set_all_simulators',
  FETCH_ALL_SIMULATOR: 'services/common/fetch_all_simulators',
  UPDATE_SIMULATOR_STATE: 'services/common/update_simulator_state',
  // Group Actions
  FETCH_ALL_GROUPS: 'services/common/fetch_all_groups',
  SET_ALL_GROUPS: 'services/common/set_all_groups',
  // Downtime Reasons
  FETCH_ALL_DOWNTIME_REASONS: 'services/common/fetch_all_downtime_reasons',
  SET_ALL_DOWNTIME_REASONS: 'services/common/set_all_downtime_reasons',
  // Equipment Actions
  FETCH_EQUIPMENT: 'services/common/fetch_equipment',
  SET_EQUIPMENT: 'services/common/set_equipment',

  // JobTitles Action
  FETCH_ALL_JOBTITLES: 'services/common/fetch_all_jobtitles',
  SET_ALL_JOBTITLES: 'services/common/set_all_jobtitles',

  ///Crew Actions
  FETCH_ALL_CREWS_BY_FACTORY: 'services/common/fetch_all_crews_by_factory',
  SET_ALL_FETCH_CREWS: 'services/common/set_all_fetch_crews',

  // Department Action
  FETCH_ALL_FACTORY_DEPARTMENTS: 'services/common/get_factory_departments',
  SET_ALL_FACTORY_DEPARTMENTS: 'services/common/set_factory_departments',
  FETCH_ALL_DEPARTMENTS: 'services/common/fetch_all_departments',
  SET_ALL_DEPARTMENTS: 'services/common/set_all_departments',

  // Update Downtime Action
  UPDATE_DOWNTIME_REASON: 'services/common/update_downtime_reason',

  // Close Downtime Action
  CLOSE_EQUIPMENT_DOWNTIME: 'services/common/close_equipment_downtime',

  // Delete Downtime Action
  DELETE_EQUIPMENT_DOWNTIME: 'services/common/delete_equipment_downtime',

  // Get OEE Equipment data by Equipment ID
  FETCH_OEE_EQUIPMENT_BY_ID: 'services/common/fetch_oee_equipment_by_id',
  SET_OEE_EQUIPMENT_BY_ID: 'services/common/set_oee_equipment_by_id',

  // Local Server SignalR
  SET_AJAX_CALL_EQUIPMENT: 'services/common/set_ajax_call_equipment',
  SET_AJAX_CALL_OEE: 'services/common/set_ajax_call_oee',
  SET_AJAX_CALL_FACTORY_EFFICIENCY: 'services/common/set_ajax_call_factory_efficiency',
  SET_AJAX_CALL_AUX: 'services/common/set_ajax_call_aux',
  SET_AJAX_CALL_ENERGY: 'services/common/set_ajax_call_energy',
  // LOCATION
  SET_LOCATION_HISTORIES: 'services/common/set_location_histories',
  // Global Pending Requests
  INCREMENT_PENDING_REQUESTS: 'services/common/increment_pending_requests',
  DECREMENT_PENDING_REQUESTS: 'services/common/decrement_pending_requests',
};
// Show/hide Side bar
const showHideSidebar = ({ toggleSidebar }) => ({
  toggleSidebar,
  type: ActionTypes.SHOW_HIDE_SIDE_BAR,
});
// Current View Global Dashboard
const currentViewGlobal = ({ currentView }) => ({
  currentView,
  type: ActionTypes.CURRENT_VIEW_GLOBAL_DASHBOARD,
});

const currentViewFactory = ({ factoyView }) => ({
  factoyView,
  type: ActionTypes.CURRENT_VIEW_FACTORY_DASHBOARD,
});
const showBackFactoryBtn = ({ showBtn }) => ({
  showBtn,
  type: ActionTypes.SHOW_BACK_FACTORY_BUTTON,
});
// set Loader after update functions
const setLoaderAfterUpdate = afterUpdateLoader => ({
  afterUpdateLoader,
  type: ActionTypes.SET_LOADER_AFTER_UPDATE,
});
// Factory functions
const fetchAllFactories = () => ({
  type: ActionTypes.FETCH_ALL_FACTORIES,
});

const setAllFactories = ({ allFactories }) => ({
  allFactories,
  type: ActionTypes.SET_ALL_FACTORIES,
});

const setAllSimulators = ({ allSimulators }) => ({
  allSimulators,
  type: ActionTypes.SET_ALL_SIMULATORS,
});

// Group functions
const fetchAllGroups = () => ({
  type: ActionTypes.FETCH_ALL_GROUPS,
});

const setAllGroups = ({ allGroups }) => ({
  allGroups,
  type: ActionTypes.SET_ALL_GROUPS,
});
// Downtime Reasons functions
const fetchAllDowntimeReasons = () => ({
  type: ActionTypes.FETCH_ALL_DOWNTIME_REASONS,
});

const setAllDowntimeReasons = ({ allDowntimeReasons }) => ({
  allDowntimeReasons,
  type: ActionTypes.SET_ALL_DOWNTIME_REASONS,
});
// Equipment functions
const fetchEquipment = ({ oeeEquipmentParams }) => ({
  oeeEquipmentParams,
  type: ActionTypes.FETCH_EQUIPMENT,
});

const setEquipment = ({ equipmentData }) => ({
  equipmentData,
  type: ActionTypes.SET_EQUIPMENT,
});

// JobTitles functions
const fetchAllJobTitles = () => ({
  type: ActionTypes.FETCH_ALL_JOBTITLES,
});

const setAllJobTitles = ({ allJobTitles }) => ({
  allJobTitles,
  type: ActionTypes.SET_ALL_JOBTITLES,
});

//// Crew functions

const fetchAllCrewsByFactoryId = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_ALL_CREWS_BY_FACTORY,
});

const setFetchAllCrews = ({ allFetchCrews }) => ({
  allFetchCrews,
  type: ActionTypes.SET_ALL_FETCH_CREWS,
});

// Departments functions
const fetchAllFactoryDepartments = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_ALL_FACTORY_DEPARTMENTS,
});

const setAllFactoryDepartments = ({ factoryDepartments }) => ({
  factoryDepartments,
  type: ActionTypes.SET_ALL_FACTORY_DEPARTMENTS,
});

const fetchAllDepartments = () => ({
  type: ActionTypes.FETCH_ALL_DEPARTMENTS,
});

const fetchAllSimulator = () => ({
  type: ActionTypes.FETCH_ALL_SIMULATOR,
});

const updateSimulatorState = ({ simulatorData }) => ({
  simulatorData,
  type: ActionTypes.UPDATE_SIMULATOR_STATE,
});

const setAllDepartments = ({ departmentsData }) => ({
  departmentsData,
  type: ActionTypes.SET_ALL_DEPARTMENTS,
});

// Udpate Downtime Reason functions
const updateDowntimeReason = ({ downtimeReasonObj, callback }) => ({
  downtimeReasonObj,
  type: ActionTypes.UPDATE_DOWNTIME_REASON,
  callback,
});

// Close Downtime functions
const closeEquipmentDowntime = ({ equipmentId }) => ({
  equipmentId,
  type: ActionTypes.CLOSE_EQUIPMENT_DOWNTIME,
});

// Delete Downtime functions
const deleteEquipmentDowntime = ({ downtimeId }) => ({
  downtimeId,
  type: ActionTypes.DELETE_EQUIPMENT_DOWNTIME,
});
// Get OEE Equipment data by Equipment ID Functions
const fetchOeeEquipmentByID = ({ oeeEquipmentId }) => ({
  oeeEquipmentId,
  type: ActionTypes.FETCH_OEE_EQUIPMENT_BY_ID,
});
const setOeeEquipmentByID = ({ equipDataById }) => ({
  equipDataById,
  type: ActionTypes.SET_OEE_EQUIPMENT_BY_ID,
});

// local serverside
const setAjaxCallEquipment = ({ ajaxCallLoopEquipment }) => ({
  ajaxCallLoopEquipment,
  type: ActionTypes.SET_AJAX_CALL_EQUIPMENT,
});
const setAjaxCallOee = ({ ajaxCallLoopOee }) => ({
  ajaxCallLoopOee,
  type: ActionTypes.SET_AJAX_CALL_OEE,
});
const setajaxCallfactoryefficiency = ({ ajaxCallfactoryefficiency }) => ({
  ajaxCallfactoryefficiency,
  type: ActionTypes.SET_AJAX_CALL_FACTORY_EFFICIENCY,
});
const setAjaxCallAux = ({ ajaxCallLoopAux }) => ({
  ajaxCallLoopAux,
  type: ActionTypes.SET_AJAX_CALL_AUX,
});

const resetDBAction = resetObj => ({
  resetObj,
  type: ActionTypes.RESET_DB,
});
const setAjaxCallEnergy = ({ ajaxCallLoopEnergy }) => ({
  ajaxCallLoopEnergy,
  type: ActionTypes.SET_AJAX_CALL_ENERGY,
});

const setLocationHistories = ({ locationHistories }) => ({
  locationHistories,
  type: ActionTypes.SET_LOCATION_HISTORIES,
});

// Global Pending Requests
const incrementPendingRequests = () => ({
  type: ActionTypes.INCREMENT_PENDING_REQUESTS,
});

const decrementPendingRequests = () => ({
  type: ActionTypes.DECREMENT_PENDING_REQUESTS,
});

export default {
  resetDBAction,
  showHideSidebar,
  currentViewGlobal,
  currentViewFactory,
  showBackFactoryBtn,
  setLoaderAfterUpdate,
  fetchAllFactories,
  setAllFactories,
  fetchAllGroups,
  setAllGroups,
  fetchAllDowntimeReasons,
  setAllDowntimeReasons,
  fetchEquipment,
  setEquipment,
  fetchAllJobTitles,
  fetchAllSimulator,
  setAllSimulators,
  updateSimulatorState,
  setAllJobTitles,
  fetchAllFactoryDepartments,
  setAllFactoryDepartments,
  fetchAllDepartments,
  setAllDepartments,
  updateDowntimeReason,
  closeEquipmentDowntime,
  deleteEquipmentDowntime,
  fetchOeeEquipmentByID,
  setOeeEquipmentByID,
  setAjaxCallEquipment,
  setAjaxCallOee,
  setajaxCallfactoryefficiency,
  setAjaxCallAux,
  setAjaxCallEnergy,

  ///
  fetchAllCrewsByFactoryId,
  setFetchAllCrews,

  //
  setLocationHistories,

  // Global Pending Requests
  incrementPendingRequests,
  decrementPendingRequests,
};
